import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatusAgentsComponent } from './status-agents.component';

const route: Routes = [
  { path: '', component: StatusAgentsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(route)],
  exports: [RouterModule]
})
export class StatusAgentsRoutingModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status-agents/status-agents-routing.module.ts